<template>
  <div class="animated fadeIn">     
    <b-row>
      <b-col md="12">
    <b-card>
          <div slot="header">
            <strong>Pending Report</strong>
            <div class="card-header-actions" >                
           
            </div>
          </div>
            <b-row class="mb-1">          
               <!--  <b-col md="4" class="my-1">
                  <b-col sm="12" >
                  <b-form-group label-cols-sm="3" label="Filter" class="mb-0">
                    <b-input-group>
                      <b-form-input v-model="filter" placeholder="Type to Search"></b-form-input>
                      <b-input-group-append>
                        <b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
                      </b-input-group-append>
                    </b-input-group>
                  </b-form-group>
                </b-col>
                </b-col> -->

                <b-col md="6" class="my-1">
                    <b-col sm="12" >
                   <b-form-group label="Delivery Agent"  label-size="sm"
                      :label-cols="3" >                   
                      <v-select id="mySelect" v-model="selectedagent" :options="this.data1" @input="pendingreport" placeholder="Search" name="selectedagent" v-validate="'required'" :class="{ danger: errors.has('selectedagent') }">
                      </v-select>
                     <!--  <span v-show="errors.has('selectedagent')" class="danger" style="color:red">
                          {{ errors.first('selectedagent') }}
                      </span>  -->   
                    </b-form-group> 
                    </b-col>   
                </b-col> 
                <b-col md="6" class="my-1">
                <b-form-group>
                 <b-button type="submit" size="md" variant="primary" @click="pendingreport"> Search</b-button>
                 &nbsp;&nbsp;&nbsp;
                  
               </b-form-group>
             </b-col>
                 
              
              </b-row>
            
              <!-- <b-row class="mb-6" v-if="showValues" > -->
                <!--  <b-col md="4" class="my-1">
                <b-form-group label="From Date:"  :label-cols="3" >
                 <v-date-picker mode='single' input-class="dateInput" :available-dates='{ start: null, end: new Date() }' v-model='selectDateFrom'>
                </v-date-picker>
                </b-form-group>
              </b-col>
              <b-col md="4" class="my-1">
                <b-form-group label="To Date:"  :label-cols="3" >
                  <v-date-picker mode='single' input-class="dateInput" :available-dates='{ start: null, end: new Date() }' v-model='selectDateTo'>
                  </v-date-picker>
                </b-form-group>
              </b-col>  -->
            <!--   <div id="overlay" >
             <div class="loader"></div>
           </div> -->
                <!--  <b-col md="4" class="my-1">
                <b-form-group>
                 <b-button type="submit" size="md" variant="primary" @click="handler"> Search</b-button> -->

                <!--  &nbsp;&nbsp;&nbsp;
                  <b-button type="submit" variant="primary" size="md" @click="downloadCSV">Download </b-button>
                </b-form-group> -->



              <!-- </b-col>-->
              <!-- </b-row>   -->
               <div id="overlay" >
             <div class="loader"></div>
           </div>
       <!--     <b-row style="border:1px solid bla">
            <b-col sm="6">
                <b-col sm="12">
                 <div>
                    <strong>Grand Total</strong>
                 </div>
             
              </b-col>
            </b-col>
                <b-col sm="6">
                  <span>66677</span>
                </b-col>
              </b-row>  -->  
              <b-row>
                <b-col sm="12" class="text-right">
                  <b-button type="submit" v-if="this.totalRows>0" variant="primary" size="md" @click="downloadCSV">Download </b-button>
                  &nbsp;&nbsp;&nbsp;
               <p > <b>Total Records :<span style="color:red;">{{totalRows }}</span></b> </p>
              </b-col>
              </b-row>        
 
            

        <b-col sm="12" >
          <b-table show-empty stacked="md"  :items="items" :busy="isBusy"    :current-page="currentPage"  :fields="fields" :per-page="perPage"  :filter="filter"   :sort-by.sync="sortBy"  :sort-desc.sync="sortDesc"   :sort-direction="sortDirection"      :bordered="bordered" > 
             <template  slot="thead-top">
                  <td colspan="8" bgcolor="white" style="font-size: 14px;"><span class=""><b>Grand Total : {{grandtotal}}</b></span></td>
                </template>
            <div slot="table-busy" class="text-center text-danger my-2">
                <b-spinner class="align-middle"></b-spinner>
                <strong>Loading...</strong>
            </div>
          </b-table>
        </b-col>
          <b-col md="12" class="my-1 " >
            <b-pagination
                v-model="currentPage"
                :total-rows="totalRows"
                :per-page="perPage"
                class="my-0"
              ></b-pagination>
          </b-col>    
        </b-card>
       
      </b-col>
    </b-row>
  </div>
</template>
<script>
import CONSTANTS from '@/utils/constants'
import Utils from '@/utils'
import Vue from 'vue'
export default {
  name: 'datewise_pendingreport', 
  data: function() {
    return {
        name: 'datewise_pendingreport',
        isBusy: false,
        // breadcrumbs: [{
        //   text: 'Dashboard',
        //   href: '/dashboard'
        // },{
        //   text: 'COD Cash Management',
        //   active: true
        // }],                 
        items:[],
        grandtotal:0,
        data1:[],
        fields: [
            { key: 'daname', label: 'Delivery Agent' },
            { key: 'delivery_date', label: 'Delivery Date'},
            { key: 'pendingcodcollectable', label: 'Pending Amount'},
           
          
              
              // { key: 'collectable_value', label: 'Deposit Amount'},
              // { key: 'pending_amount', label: ' Cod Pending  Amount '},
              // { key: 'payment_mode_status', label: 'Payment Mode'}  ,
              // { key: 'receipt_no', label: 'Receipt No'} ,
              // { key: 'remark', label: 'Remark'}  ,
              // { key: 'action', label: 'Date',sortable: true}  ,
              
                                         
         ], 
        bordered: true,
        totalRows: 0,
        currentPage: 1,
        perPage:  20,
        pageOptions: [5, 10, 15],
        sortBy: null,
        sortDesc: false,
        sortDirection: 'desc',
        filter: null,
        currenthubidselct:'',
        selectDateFrom: new Date(),
        selectDateTo:new Date(),
        selectedagent:'',
        // showValues:false
    }
  },
  created: function() {  
    this.displaydata();
    this.pendingreport();
    // var userdata = localStorage.getItem('userData')
    // var userInfo = JSON.parse(userdata)
    // this.currenthubidselct=userInfo.pickuplocationmasterid.toString();
     
  },
  // computed: {
  //     sortOptions() {
  //       // Create an options list from our fields
  //       return this.fields
  //         .filter(f => f.sortable)
  //         .map(f => {
  //           return { text: f.label, value: f.key }
  //         })
  //     }
  //   },
  methods: {
    pendingreport:function(){
       var userdata = localStorage.getItem('userData')
      var userInfo = JSON.parse(userdata)
       // this.showValues=true;
      this.isBusy = true;
       var deliveryagentid=(this.selectedagent!=null)? this.selectedagent:"";


       if(this.selectedagent!='' &&  this.selectedagent!=null){

       const pendingObj = {
        deliveryagentmasterid:this.selectedagent.key,
        hub_id:`${userInfo.pickuplocationmasterid}`,
        is_finance_superadmin:`${userInfo.is_finance_superadmin}`,
      }
      // console.log("ifObj",pendingObj);
  
    

      // const reportObj={},
     this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/getdatewisependingreportofrider`, pendingObj)
        .then((result) => {
          // this.agentmaster = result.body;
          // console.log("result",result);
           if (result.body.returnmsg === 'Successful') {
             // this.currentPage=1;
             this.items  = result.body.returnvalue;
             this.grandtotal= result.body.returnvalue[0].grandtotal;

             // console.log("tthis.grandtotal ",this.grandtotal );
             this.totalRows = result.body.returnvalue.length;
             this.isBusy = !this.isBusy;
          } else {
            this.items=[];
            this.totalRows =0;
             this.grandtotal=0;
            this.isBusy = !this.isBusy;
          }
        })
        .catch((ex) => {
          console.log('error', ex)
        })
      }else{


        const pendingObj = {
          hub_id:`${userInfo.pickuplocationmasterid}`,
        is_finance_superadmin:`${userInfo.is_finance_superadmin}`,
        }
      // console.log("ifObj",pendingObj);
  
    

      // const reportObj={},
     this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/getdatewisependingreportofrider`, pendingObj)
        .then((result) => {
          // this.agentmaster = result.body;
          // console.log("result",result);
           if (result.body.returnmsg === 'Successful') {
             // this.currentPage=1;
             this.items  = result.body.returnvalue;
              this.grandtotal= result.body.returnvalue[0].grandtotal;
             // console.log("this.items ",this.grandtotal );
             this.totalRows = result.body.returnvalue.length;
             this.isBusy = !this.isBusy;
          } else {
            this.items=[];
            this.totalRows =0;
              this.grandtotal=0;
            this.isBusy = !this.isBusy;
          }
        })
        .catch((ex) => {
          console.log('error', ex)
        })
      }

    },
     downloadCSV: function() {
       document.getElementById("overlay").style.display = "block";
     var userdata = localStorage.getItem('userData')
      var userInfo = JSON.parse(userdata)
     // var fromdate = (this.selectDateFrom!=null)?this.formatDate(this.selectDateFrom):"";
     //  var formatdateto=(this.selectDateTo!=null)? this.formatDate(this.selectDateTo):"";
          var csvObj = {
            // deliveryagentmasterid:this.selected.key,
            // fromdate: `${fromdate}`,
            // todate:`${formatdateto}`,
            sysusermasterid:`${userInfo.sysusermasterid}`,
            hub_id:`${userInfo.pickuplocationmasterid}`,
            is_finance_superadmin:`${userInfo.is_finance_superadmin}`,
            // hub_id:`${userInfo.pickuplocationmasterid}`,
          };
          // console.log("csvObj",csvObj);

//         var queryString ="?"+ Object.keys(csvObj).map(key => key + '=' + csvObj[key]).join('&');
// console.log(queryString);
      // if(formatdateto< fromdate){
      //   // alert('To date need to be grater than From date');
      //   this.$fire({
      //             text:"To date need to be grater than From date",
      //             type: "warning",
      //             timer: 30000
      //           });    
          
      // }
      //var r = Math.random().toString(36).substring(3);
      this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/getdatewisependingreportofridercsv`,csvObj)
        .then(result => {
         // console.log(result.url);
            document.getElementById("overlay").style.display = "none";
         if(result.body=="success")
         {
        //  alert("Please Check Ur Mail For Downlod Link")
          this.$fire({
                  text:"Please Check Your Mail For Downlod Link",
                  type: "success",
                  timer: 30000
                });  
       }
       else
       {
        // alert("Can not Download");
        this.$fire({
                  text:"Can not Download",
                  type: "error",
                  timer: 30000
                });  
       }
        //window.location.href =result.url;
        });

        
    },
//     handler:function(paymentParams,dagentid) {
//       var userdata = localStorage.getItem('userData')
//       var userInfo = JSON.parse(userdata)
//        this.showValues=true;
//       this.isBusy = true;
//       var userdata = localStorage.getItem('userData')
//       var userInfo = JSON.parse(userdata)
//       this.currenthubidselct=userInfo.pickuplocationmasterid.toString();
      
//       var fromdate = (this.selectDateFrom!=null)?this.formatDate(this.selectDateFrom):"";
//         var formatdateto=(this.selectDateTo!=null)? this.formatDate(this.selectDateTo):"";
      
//       if(this.selected!='' &&  this.selected!=null){

//        const codinfo = {
//         deliveryagentmasterid:this.selected.key,
//           fromdate: `${fromdate}`,
//           todate:`${formatdateto}` ,
//           hub_id:`${userInfo.pickuplocationmasterid}`,

//       }
// // console.log(codinfo);
//       this.$http.post(`${CONSTANTS.API_URL}/getcodshipmentclosurelog`,codinfo)
//         .then((result) => {     

//           if (result.body.returnmsg === 'Successful') {
//              this.currentPage=1;
//              this.items  = result.body.returnvalue;
//              this.totalRows = result.body.returnvalue.length;
//              this.isBusy = !this.isBusy;
//           } else {
//             this.items=[];
//             this.totalRows =0;
//             this.isBusy = !this.isBusy;
//           }
//         }).catch((ex) => {
//           console.log('error-----', ex)
//         })
//       }else{
//          this.items=[];
//             this.totalRows =0;
//             this.isBusy = !this.isBusy;
//             this.currentPage=1;
//       }
//     },

//Code Added by Sachin
//Date: 06/04/2020
//   downloadCSV: function() {
//        document.getElementById("overlay").style.display = "block";
//      var userdata = localStorage.getItem('userData')
//       var userInfo = JSON.parse(userdata)
//      var fromdate = (this.selectDateFrom!=null)?this.formatDate(this.selectDateFrom):"";
//       var formatdateto=(this.selectDateTo!=null)? this.formatDate(this.selectDateTo):"";
//           if(this.selected!='' &&  this.selected!=null){
//           var csvObj = {
//             deliveryagentmasterid:this.selected.key,
//             fromdate: `${fromdate}`,
//             todate:`${formatdateto}`,
//             sysusermasterid:`${userInfo.sysusermasterid}`,
//             hub_id:`${userInfo.pickuplocationmasterid}`,
//           };

// //         var queryString ="?"+ Object.keys(csvObj).map(key => key + '=' + csvObj[key]).join('&');
// // console.log(queryString);
//       if(formatdateto< fromdate){
//         // alert('To date need to be grater than From date');
//         this.$fire({
//                   text:"To date need to be grater than From date",
//                   type: "warning",
//                   timer: 30000
//                 });    
          
//       }
//       //var r = Math.random().toString(36).substring(3);
//       this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/getcodmanagementcsv_advanced`,csvObj)
//         .then(result => {
//          console.log(result.url);
//             document.getElementById("overlay").style.display = "none";
//          if(result.body=="success")
//          {
//          // alert("Please Check Ur Mail For Downlod Link")
//           this.$fire({
//                   text:"Please Check Ur Mail For Downlod Link",
//                   type: "success",
//                   timer: 30000
//                 });  
//        }
//        else
//        {
//         // alert("Can not Download");
//         this.$fire({
//                   text:"Can not Download",
//                   type: "error",
//                   timer: 30000
//                 });  
//        }
//         //window.location.href =result.url;
//         });

//         }
//     },
//     downloadCSV: function() {
      

//      var fromdate = (this.selectDateFrom!=null)?this.formatDate(this.selectDateFrom):"";
//       var formatdateto=(this.selectDateTo!=null)? this.formatDate(this.selectDateTo):"";
//           if(this.selected!='' &&  this.selected!=null){
//           var csvObj = {
//             deliveryagentmasterid:this.selected.key,
//             fromdate: `${fromdate}`,
//             todate:`${formatdateto}`,
//           };

//         var queryString ="?"+ Object.keys(csvObj).map(key => key + '=' + csvObj[key]).join('&');
// // console.log(queryString);
//       if(formatdateto< fromdate){
//         alert('To date need to be grater than From date');
          
//       }
//       //var r = Math.random().toString(36).substring(3);
//       this.$http
//         .get(`${CONSTANTS.MIGRATION_API_URL}/getcodmanagementcsv`+queryString)
//         .then(result => {
//          // console.log(result.url);
//         window.location.href =result.url;
//         });

//         }
//     },
//Added code ends


// formatDate: function(date) {
//       var d = new Date(date),
//         month = "" + (d.getMonth() + 1),
//         day = "" + d.getDate(),
//         year = d.getFullYear();
//       if (month.length < 2) month = "0" + month;
//       if (day.length < 2) day = "0" + day;
//       return [year, month, day].join("-");
//     },

    displaydata: function () {
        var userdata = localStorage.getItem('userData')
        var userInfo = JSON.parse(userdata)
        const deliveryagentobj = {
          deliveryagentpincode: `${userInfo.pickuplocationpincode}`,
          isactive: '1',
           hub_id:`${userInfo.pickuplocationmasterid}`,
           is_finance_superadmin:`${userInfo.is_finance_superadmin}`,
        }
  this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/deliveryagentmastergetall`, deliveryagentobj)
  .then(result => {
            this.data1 = result.body;          
            var data = [];
 
              result.body.forEach(function (srData) {
                data.push({
                  key:srData.deliveryagentmasterid,
                  label:srData.deliveryagentfirstname+ '  '+srData.deliveryagentlastname+ ' - '+srData.deliveryagentmasterid
                });
              });
              this.data1 = data;
              this.data1.unshift({"label": "All", "key": 0});

        }).catch(ex => {
            console.log('error-----', ex)
        });
    }
    
  },
  filters: {
    datechange: function(value) {
      if(value==null){
       return '-';
      }else{
        var d = new Date(value)
        var curr_date = (d.getDate() < 10 ? '0' : '') + d.getDate();
        var month = d.getMonth() + 1;
        var curr_year = d.getFullYear();
        var curr_month = month < 10 ? '0' + month : '' + month;
        var hours = d.getHours();
        var minutes = d.getMinutes();
        var ampm = hours >= 12 ? 'pm' : 'am';
        hours = hours % 12;
        hours = hours ? hours : 12; // the hour '0' should be '12'
        minutes = minutes < 10 ? '0'+minutes : minutes;
        var strTime = hours + ':' + minutes + ' ' + ampm;
        return curr_date + '-' + curr_month + '-' + curr_year+' : '+ " " + strTime;
      }
    }
  }
 
};
</script>

<style>
  /* IE fix */
  #card-chart-01, #card-chart-02 {
    width: 100% !important;
  }

   #mySelect  {
   width: 230px;
}
#overlay {
  position: fixed; /* Sit on top of the page content */
  display: none; /* Hidden by default */
  width: 100%; /* Full width (cover the whole page) */
  height: 100%; /* Full height (cover the whole page) */
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0,0,0,0.5); /* Black background with opacity */
  z-index: 2; /* Specify a stack order in case you're using a different order for other elements */
  cursor: pointer; /* Add a pointer on hover */
}
  .loader {
  position: relative;
  border: 5px solid #f3f3f3;
  border-radius: 50%;
  border-top: 5px solid #3498db;
  width: 30px;
  height: 30px;
  left:50%;
  top:50%;
  -webkit-animation: spin 2s linear infinite; /* Safari */
  animation: spin 2s linear infinite;
}


/* Safari */
@-webkit-keyframes spin {
  0% { -webkit-transform: rotate(0deg); }
  100% { -webkit-transform: rotate(360deg); }
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
</style>
